export default "__VITE_ASSET__e84eH$xD__"